import { lazy } from 'react';

import { retry } from 'src/utils/routing';

export default {
    name: 'attachment',
    path: '/attachment?qrid&tn',
    component: () => lazy(() => retry(() => import('./index')))
};
